import React, { useContext, useEffect, useRef, useState } from 'react';

import { ChevronDown, ChevronUp, Filter } from 'lucide-react';

import Popover from 'common/common/Popover';
import Portal from 'common/common/Portal';
import { LocationContext } from 'common/containers/RouterContainer';
import useBackgroundClick from 'common/hooks/useBackgroundClick';
import ButtonV2 from 'common/ui/ButtonV2';

import 'css/components/subdomain/admin/_AdminQueueFilters.scss';

type Props = {
  resetFilters: () => void;
  children: React.ReactNode;
};

const FiltersPopover = ({ children, resetFilters }: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  const buttonRef = useRef(null);
  const portalRef = useRef(null);
  const location = useContext(LocationContext);

  useBackgroundClick(() => setOpen(false), [portalRef, buttonRef]);

  useEffect(() => {
    if (location.query.postURLName && open) {
      setOpen(false);
    }
  }, [location.query.postURLName, open]);

  return (
    <>
      <ButtonV2
        startIcon={Filter}
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        endIcon={open ? ChevronUp : ChevronDown}
        variant="outlined"
        size="medium">
        Filters
      </ButtonV2>
      {open && (
        <Portal
          align="end"
          ref={portalRef}
          className="filtersPopoverContainer"
          relativeToRef={buttonRef}>
          <Popover
            cta={
              <ButtonV2
                size="medium"
                variant="plain"
                aria-label="Reset filters"
                onClick={resetFilters}>
                Reset
              </ButtonV2>
            }
            title="Filters">
            <div className="accordions">{children}</div>
          </Popover>
        </Portal>
      )}
    </>
  );
};

export default FiltersPopover;
